import React from 'react';
import '../../../assets/css/CurriculumVitae/style.css';

function WizardLayout({children, currentStep, totalSteps, onNext, onPrevious, onStepChange, isNextDisabled, stepCompletion}) {
    return (
        <div className="container-fluid">
            <div className="text-center title p-4">
                <h1>Curriculum Vitae</h1>
                <ProgressBar currentStep={currentStep} totalSteps={totalSteps} onStepClick={onStepChange} stepCompletion={stepCompletion}/>
            </div>

            <div className="d-flex justify-content-end mt-4 mb-2 button-group">
                <button onClick={onPrevious} className="btn btn-secondary mr-3" disabled={currentStep === 1}>
                    Previous
                </button>
                <button onClick={onNext} disabled={isNextDisabled} className="btn btn-primary">
                    {currentStep === totalSteps ? 'Finish' : 'Next'}
                </button>
            </div>

            <div className="t4t-card p-4 mb-4">{children}</div>
        </div>
    );
}

function ProgressBar({currentStep, totalSteps, onStepClick, stepCompletion}) {
    return (
        <div className="step-indicator">
            {[...Array(totalSteps)].map((_, index) => {
                const step = index + 1;
                const isCompleted = stepCompletion[step];
                const isPreviousStepCompleted = step > 1 && stepCompletion[step - 1];
                const isStepDisabled = step > currentStep && !isPreviousStepCompleted;

                return (
                    <button
                            key={index}
                            onClick={() => onStepClick(step)}
                            disabled={isStepDisabled}
                            className={`step ${step === currentStep ? 'active' : ''} ${isCompleted ? 'completed' : ''} ${isStepDisabled ? 'disabled' : ''}`}
                    >
                        <span className={`step-number ${step === currentStep ? 'active-number' : ''}`}>
                            {step}
                        </span>
                    </button>
                );
            })}
        </div>
    );
}

export default WizardLayout;
